import { LogoMark } from "@/components/Logo";
import InstallButton from "@/components/InstallButton";
import { scrollToId } from "@/lib/scroll";

export default function Footer() {
  return (
    <footer
      id="colophon"
      data-testid="footer-section"
      className="relative z-10 overflow-hidden border-t border-[#D4AF37]/15 bg-[#0B0C10] pt-20"
    >
      <div className="mx-auto max-w-[1680px] px-5 lg:px-16">
        <div className="flex flex-col gap-10 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-md">
            <div className="flex items-center gap-3">
              <LogoMark className="h-10 w-10" />
              <span className="font-mono text-[10px] tracking-[0.4em] text-[#D4AF37]">
                CHRONO-ATLAS
              </span>
            </div>
            <p className="mt-6 font-serif text-2xl italic leading-snug text-white/80">
              “A curious atlas, not a verdict.
              <br />
              The truth keeps its options open.”
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <InstallButton />
              <a
                href="/review"
                data-testid="footer-review-link"
                className="inline-flex items-center gap-3 border border-white/15 px-5 py-3 font-mono text-[9px] tracking-[0.3em] text-white/45 transition-colors hover:border-[#38BDF8] hover:text-[#38BDF8]"
              >
                KEEPER'S REVIEW
              </a>
            </div>
          </div>

          <button
            data-testid="footer-top-button"
            onClick={() => scrollToId("#top")}
            className="group flex items-center gap-4 self-start font-mono text-[10px] tracking-[0.3em] text-white/50 transition-colors hover:text-[#D4AF37] lg:self-end"
          >
            <span className="inline-block h-px w-10 bg-current transition-all duration-300 group-hover:w-16" />
            BACK TO ORBIT
          </button>
        </div>

        <div className="mt-16 select-none text-center font-serif text-[19vw] font-light leading-[0.8] tracking-tight text-[#D4AF37]/10 lg:text-[15rem]">
          AETHERIA
        </div>

        <div className="flex flex-col items-center justify-between gap-3 border-t border-white/10 py-7 font-mono text-[9px] tracking-[0.2em] text-white/35 sm:flex-row">
          <span>© {new Date().getFullYear()} AETHERIA — AN ATLAS OF OPEN QUESTIONS</span>
          <span>GLOBE: THREE.JS · TYPE: CORMORANT GARAMOND · IMAGERY: UNSPLASH + ARTIST IMPRESSIONS</span>
        </div>
      </div>
    </footer>
  );
}
